
export class EventEmitter {
    events: any = {};

    addListener(event: any, listener: Function): number {
        if (typeof this.events[event] !== 'object') {
            this.events[event] = [];
        }

        return this.events[event].push(listener);
    }

    removeListener(event: any, listener: Function): void {
        let idx;

        if (typeof this.events[event] === 'object') {
            idx = this.events[event].indexOf(listener);

            if (idx > -1) {
                this.events[event].splice(idx, 1);
            }
        }
    }

    removeListenerById(event: any, listenerId: number): void {
        const idx = listenerId - 1;

        if (typeof this.events[event] === 'object') {
            if (this.events[event].length > idx) {
                this.events[event].splice(idx, 1);
            }
        }
    }

    emit(event: any, data: any): Promise<any[]> {
        if (typeof this.events[event] === 'object'
            && this.events[event].length > 0) {

            const promises = this.events[event].map((listener: Function) => {
                const result = listener(data);

                return result;
            });

            return Promise.all(promises);
        }

        return Promise.resolve([]);
    }
}
